import { Injectable } from '@angular/core';
import { GenericTrialInsightsTable } from '../../classes/trial-insights-table.class';

@Injectable()
export class TrialInsightsFinanceBvaChartTableService extends GenericTrialInsightsTable {
  constructor() {
    super({});
  }
}
